import React from 'react';
import Services from '../../components/Services';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const ServicesPage: React.FC = () => {
  return (
    <div className="pt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
         <div className="bg-mira-surface border border-mira-border rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-mira-accent/10 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2"></div>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight text-white drop-shadow-[0_0_15px_rgba(26,140,255,0.3)]">
               Soluciones <span className="text-mira-accent">Tecnológicas</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed font-medium">
              Descubre cómo nuestras herramientas de Inteligencia Artificial pueden integrarse perfectamente en tu flujo de trabajo actual.
            </p>
         </div>
      </div>
      
      {/* Reusing the Services Component but treating it as main content here */}
      <div className="bg-mira-bg">
        <Services />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-20">
        <div className="relative rounded-3xl overflow-hidden border border-mira-border bg-gradient-to-b from-mira-surface to-mira-bg p-10 md:p-16 text-center group">
            {/* Glow effects */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-full bg-mira-accent/5 blur-[80px] -z-10"></div>
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-mira-accent/50 to-transparent"></div>

            <div className="inline-flex items-center justify-center p-3 bg-mira-accent/10 rounded-xl mb-6 border border-mira-accent/20 shadow-[0_0_15px_rgba(26,140,255,0.2)]">
              <Sparkles className="w-6 h-6 text-mira-accent" />
            </div>

            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 tracking-tight">
                ¿No encuentras lo que <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">buscas?</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-10 leading-relaxed font-medium">
                Cada negocio es único. Si necesitas una integración específica, un CRM complejo o un flujo a medida, 
                nuestro equipo de ingenieros puede desarrollarlo desde cero para ti.
            </p>

            <Link
                to="/contacto"
                className="inline-flex items-center gap-3 px-8 py-4 bg-mira-accent text-mira-bg font-bold text-lg rounded-full hover:bg-blue-400 transition-all transform hover:-translate-y-1 hover:shadow-[0_0_30px_rgba(26,140,255,0.5)]"
            >
                Solicitar Solución Personalizada <ArrowRight className="w-5 h-5" />
            </Link>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;